import { Text } from "@fluentui/react-components";
import { CircleSmallFilled, Info16Regular } from "@fluentui/react-icons";
import { devices } from "library/constants";
import { formatNumber } from "library/utils";
import { TreeMapComponent } from "pages/Dashboard/components/TreeMap/TreeMapComponent/TreeMapComponent";
import styled, { useTheme } from "styled-components";

import { ButtonWithTooltip } from "components/ButtonWithTooltip/ButtonWithTooltip";
import { Flex } from "components/styled";
import { useIsMobile } from "hooks/useIsMobile";
import { useWindowWidth } from "hooks/useWindowWidth";

type Props = {
  name: string;
  data: {
    name: string;
    size: number;
    color: string;
    currency: string;
  }[];
  fill?: string;
};

export function TreeMapCard({ data, name, fill }: Props) {
  const isMobile = useIsMobile();
  const { width } = useWindowWidth();

  const theme = useTheme();

  const treeMapData = [
    {
      name,
      children: data,
    },
  ];

  return (
    <Container>
      <Flex $justify="space-between" style={{
          height: "35px"
        }}>
        <Title weight="bold">{name}</Title>
        {/* <ButtonWithTooltip tooltipContent="TODO" icon={<Info16Regular />} /> */}
      </Flex>
      <TreeMapWrap $width={width}>
        <TreeMapComponent
          width={isMobile ? width - 40 : 239}
          height={180}
          data={treeMapData}
          stroke={theme.palette.white}
          fill={fill}
        />
      </TreeMapWrap>
      <div>
        {data.map((item, index) => {
          return (
            <Flex $justify="flex-start" key={item.name}>
              <CircleSmallFilled
                style={{
                  color: data[index].color,
                }}
              />
              <Text
                truncate
                size={200}
                style={{
                  color: theme.palette.neutralDark,
                }}
              >
                {item.name} - {formatNumber(item.size)} {item.currency}
              </Text>
            </Flex>
          );
        })}
      </div>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  gap: 10px;
  background: ${(props) => props.theme.semanticColors.cardStandoutBackground};
  border: 1px solid ${(props) => props.theme.palette.neutralLight};
  border-radius: 6px;
  width: fit-content;
`;

const TreeMapWrap = styled.div<{ $width: number }>`
  width: ${(props) => props.$width - 40}px;

  @media only screen and ${devices.md} {
    width: 239px;
    height: 180px;
  }
`;
const Title = styled(Text)`
  font-size: 15px;
`;
